import React, {Component} from 'react';
import { observer , inject } from 'mobx-react';
import { getInitiation, getMonthlyDues, getAnnualFee, getAmountDueToday, getSaleDuration, isCommitVerbage, bestValue } from './ProductInfoItems.js';

class SingleProduct extends Component {

    membershipDetailsPressed(e){
        //product ID's and club ID's
        this.props.DGRStore.setProductID(e.target.name)

        this.props.DGRModalStore.setSection('productDetails')
        this.props.DGRModalStore.setCloseVisible()
        this.props.DGRModalStore.openModal()
    }
    selectProductPressed(e){
        const {selectFunction} = this.props
        selectFunction(e)
    }

    constructor(props){
        super(props);
        this.membershipDetailsPressed = this.membershipDetailsPressed.bind(this)
        this.selectProductPressed = this.selectProductPressed.bind(this)
    }

    render(){
        const product = this.props.product
        return (
            <div className="productCard">
                <div className="productCardFlex">
                    <div className="productLeft">
                        <div className="title">
                            <span className="titleName">{product.name}</span>
                            { bestValue( product ) }
                        </div>
                        <div className="productInfo">
                            <p className="subinfo">
                              {isCommitVerbage(product)}
                              &nbsp;
                              <button
                              className ="memberDetails"
                              name={ product.popup_id }
                              onClick={this.membershipDetailsPressed}>
                                  See Membership Details
                              </button>
                            </p>
                        </div>
                        {getSaleDuration(product)}
                    </div>
                    <div className="productRight">
                        {getMonthlyDues(product)}
                        {getInitiation(product)}
                        {getAnnualFee(product)}
                        {getAmountDueToday(product)}
                        <button
                            onClick= {this.selectProductPressed}
                            name={product.id}
                            value={product.id}
                            className="bigButton">Select
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

SingleProduct = inject('DGRStore','DGRModalStore')(observer(SingleProduct))
export default SingleProduct



// WEBPACK FOOTER //
// ./src/components/DGR/MembershipOptions/SingleProduct.js